const oidc = {
    logout_success: 'You have successfully signed out.', // UNTRANSLATED
};
export default oidc;
